export const POST_LIST_ID = '667a61eea26cefc2079f98da';
export const POST_VIEW_ID = '667a61eea26cefc2079f98db';
export const POST_CREATE_ID = '667a61eea26cefc2079f98dc';
export const POST_UPDATE_ID = '667a61eea26cefc2079f98de';
export const POST_DELETE_ID = '667a61eea26cefc2079f98df';
export const POST_PUBLISH_ID = '667a61eea26cefc2079f98e0';
export const POST_UNPUBLISH_ID = '667a61eea26cefc2079f98e2';
export const MEDIA_PUBLISH_ID = '667a61eea26cefc2079f98e3';
export const MEDIA_UNPUBLISH_ID = '667a61eea26cefc2079f98e4';
export const MEDIA_LIST_ID = '667a61eea26cefc2079f98e6';
export const MEDIA_VIEW_ID = '667a61eea26cefc2079f9812';
export const MEDIA_CREATE_ID = '667a61eea26cefc2079f98a5';
export const MEDIA_UPDATE_ID = '667a61eea26cefc2079f0916';
export const MEDIA_DELETE_ID = '667a61eea26cefc2079f98d3';
export const USER_CREATE_ID = '667a61eea26cefc2079f9169';
export const USER_LIST_ID = '667a61eea26cefc2079f9854';
export const USER_EDIT_ID = '667a61eea26cefc2079f9845';
export const USER_DELETE_ID = '667a61eea26cefc2079f9a18';
export const MASTER_CREATE_ID = '667a61eea26cefc2079f9112';
export const MASTER_LIST_ID = '667a61eea26cefc2079f9851';
export const MASTER_EDIT_ID = '667a61eea26cefc2079f9451';
export const MASTER_DELETE_ID = '667a61eea26cefc2079f9a19';
export const DASHBOARD_VIEW_ID = '667a61eea26cefc2079f9097';
export const LOG_VIEW_ID = '667a61eea26cefc2079f9a15';